/**
 * Resolves the Socket.IO server URL.
 * Prefer VITE_SOCKET_URL; fall back to VITE_API_BASE_URL without the /api suffix.
 */
export const getSocketUrl = () => {
  const fromSocketEnv = import.meta.env.VITE_SOCKET_URL;
  if (fromSocketEnv) {
    return String(fromSocketEnv).replace(/\/$/, '');
  }

  const apiBase = import.meta.env.VITE_API_BASE_URL;
  if (apiBase) {
    return String(apiBase).replace(/\/api\/?$/, '').replace(/\/$/, '');
  }

  return undefined;
};

export const getSocketClientOptions = (authToken) => ({
  // Polling first is more reliable behind reverse proxies (nginx, TLS).
  transports: ['polling', 'websocket'],
  auth: {token: authToken},
  reconnection: true,
});
